/**
 * @generated SignedSource<<29a07620b053c72705206ec16d0a0d5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeOnboardingCoachmarkConditionalLoader_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "TradeOnboardingCoachmarkConditionalLoader_item";
};
export type TradeOnboardingCoachmarkConditionalLoader_item$key = {
  readonly " $data"?: TradeOnboardingCoachmarkConditionalLoader_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeOnboardingCoachmarkConditionalLoader_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeOnboardingCoachmarkConditionalLoader_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b85597d13658b133a50c92954559b8e0";

export default node;
